module.exports = __webpack_public_path__ + "img/Soukhim.912314f6.png";